module.exports = __webpack_public_path__ + "static/media/Larvesta_gaussian2.c3503097.png";